export const CATEGORY_GROUP_MAP = {
  "cologne-elixir": "eau-de-parfum",
  "eau-de-cologne": "eau-de-parfum",
  "eau-de-toilette": "eau-de-parfum",
  "cologne-intense": "extrait-de-parfum",
  "eau-de-cologne-intense": "extrait-de-parfum",
  "body-oil": "body-oil-lotion",
  "body-lotion": "body-oil-lotion",
  "car-perfume-adapter": "car-perfume",
  "car-perfume-refill": "car-perfume",
};

export const slugifyCategoryValue = (value = "") =>
  value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/gi, "-")
    .replace(/(^-|-$)+/g, "");

export const canonicalCategorySlug = (category) => {
  const rawSlug = slugifyCategoryValue(
    category?.handle || category?.name || category?.title || ""
  );
  return CATEGORY_GROUP_MAP[rawSlug] || rawSlug;
};

export const getCategoryLabel = (category, t) => {
  const canonicalSlug = canonicalCategorySlug(category);
  const defaultLabel =
    category?.name || category?.title || canonicalSlug.replace(/-/g, " ");
  return t
    ? t(`catalog.categories.${canonicalSlug}`, { defaultValue: defaultLabel })
    : defaultLabel;
};

export const getLocalizedCategorySlug = (category, t) =>
  slugifyCategoryValue(getCategoryLabel(category, t));

export const groupCategoriesForDisplay = (categories = [], t) => {
  const grouped = new Map();

  categories.forEach((category) => {
    if (!category) return;

    const canonicalSlug = canonicalCategorySlug(category);
    const label = getCategoryLabel(category, t);
    const slug = canonicalSlug;

    if (!grouped.has(slug)) {
      grouped.set(slug, {
        slug,
        label,
        ids: [category.id],
        canonicalSlug,
      });
    } else {
      grouped.get(slug)?.ids.push(category.id);
    }
  });

  return Array.from(grouped.values());
};

export const categoryMatchesSelection = (category, selectedSlugs = [], t) => {
  if (!selectedSlugs?.length) return false;
  const canonicalSlug = canonicalCategorySlug(category);
  const localizedSlug = getLocalizedCategorySlug(category, t);
  return (
    selectedSlugs.includes(canonicalSlug) || selectedSlugs.includes(localizedSlug)
  );
};
